import Storage from '@/utils/storagehandle'
const club = {
    namespaced: true,
    state: {
        // 项目
        programList: Storage.getItem('programList')||[],
        // 班级
        classList: Storage.getItem('classList')||[],
        // 年级
        gradeList: Storage.getItem('gradeList')||[]
    },
    mutations: {
        // 修改赛事的全局数据
        CHANGE_PROGRAM_LIST (state, programList) {
            state.programList = programList
            Storage.setItem(`programList`, state.programList)
        },
        // 修改班级列表
        CHANGE_CLASS_LIST (state, classList) {
            state.classList = classList
            Storage.setItem(`classList`, state.classList)
        },
        // 保存年级列表
        CHANGE_GRADE_LIST (state, gradeList) {
            state.gradeList = gradeList
            Storage.setItem(`gradeList`, state.gradeList)
        }
    },
    actions: {
    },
    getters: {
        programList: state => state.programList,
        classList: state => state.classList,
        gradeList: state => state.gradeList
    }
}
export default club



// WEBPACK FOOTER //
// ./src/store/modules/club.js